module.exports = {
  projects: [
    {
        title: 'Midnight S1 RWF Chars',
        liveLink: 'https://dbowers.io/rwf-split-chars/',
        ghLink: 'https://github.com/ennukee/rwf-split-chars',
        description: 'Visualizations for gear distribution in RWF guilds during Midnight S1 RWF',
        created: '2026-03-23'
    },
    {
        title: 'Midnight S1 Crest Planner',
        liveLink: 'https://dbowers.io/midnight-s1-crests/',
        ghLink: 'https://github.com/ennukee/midnight-s1-crests',
        description: 'Tool to help plan out the use of pre-season upgrade currency for WoW Midnight season 1',
        created: '2026-03-13'
    },
    {
        title: 'Midnight S1 PvP Planner',
        liveLink: 'https://dbowers.io/midnight-s1-pvp/',
        ghLink: 'https://github.com/ennukee/midnight-s1-pvp',
        description: 'Tool to help plan out the use of PvP gear to accelerate progression for WoW Midnight season 1',
        created: '2026-03-10'
    },
    {
        title: 'Midnight SimC Planner',
        liveLink: 'https://dbowers.io/midnight-simc-gen/',
        ghLink: 'https://github.com/ennukee/midnight-simc-gen',
        description: 'Updated version of the older SimC Gen tools for WoW Midnight',
        created: '2026-02-27'
    },
    {
        title: 'Alt Manager Addon',
        liveLink: 'https://www.curseforge.com/wow/addons/altism-manager',
        ghLink: 'https://github.com/ennukee/altism-manager',
        description: 'addon for world of warcraft to help manage info about many characters',
        created: '2025-04-12'
    },
    {
        title: 'WoW PTR Log Scanner', ghLink: 'https://github.com/ennukee/wow-ptr-log-scanner',
        description: 'node script to create a community sheet for data analytics about ptr raid tests',
        created: '2025-01-11'
    },
    {
        title: 'TWW SimC Gen', ghLink: 'https://github.com/ennukee/tww-simc-gen', liveLink: 'https://dbowers.io/tww-simc-gen/',
        description: 'An updated version of DF SimC Gen (below) for WoW 11.0',
        created: '2024-09-08'
    },
    {
        title: 'TWW Level Plan', ghLink: 'https://github.com/ennukee/tww-xp-planner', liveLink: 'https://ennukee.github.io/tww-xp-planner/',
        description: 'tool to help plan leveling routes for WoW TWW expansion launch',
        created: '2024-08-05'
    },
    {
        title: 'PoE Atlas Overview', ghLink: 'https://github.com/ennukee/poe-atlas-overview', liveLink: 'https://dbowers.io/poe-atlas-overview/',
        description: 'assists with organizing plans for PoE Atlas progression in 3.25 by highlighting categories by mechanic',
        created: '2024-07-23'
    },
    {
        title: 'Tinctures', ghLink: 'https://github.com/ennukee/tinctures', liveLink: 'https://dbowers.io/tinctures/',
        description: 'tool to generate a trade search query to look up Tinctures in PoE 3.23, prior to a supporting update',
        created: '2023-12-09'
    },
    {
        title: 'DF SimC Gen', ghLink: 'https://github.com/ennukee/df-simc-gen', liveLink: 'https://dbowers.io/df-simc-gen/',
        description: 'tool to create profilesets for WoW: Dragonflight Simc to simplify minmaxing',
        created: '2023-06-28'
    },
    {
        title: 'Crucible Filter', ghLink: 'https://github.com/ennukee/crucible-filter', liveLink: 'https://dbowers.io/crucible-filter/',
        description: 'tool to help simplify searching for the super vast crucible tree mod list in PoE 3.21',
        created: '2023-04-29'
    },
    {
        title: 'PoE Waitlist', ghLink: 'https://github.com/ennukee/poe-waitlist', liveLink: 'https://dbowers.io/poe-waitlist/',
        description: 'tool to help PoE service providers keep track of wait lists',
        created: '2023-04-13'
    },
    {
        title: 'Exile Leveling', ghLink: 'https://github.com/heartofphos/exile-leveling', liveLink: 'https://heartofphos.github.io/exile-leveling/#/',
        description: 'open source tool I\'ve contributed to that helps streamline the campaign in PoE',
        created: '2023-02-28'
    },
    {
        title: 'Gem Planner V2', ghLink: 'https://github.com/ennukee/gemplanner', liveLink: 'https://dbowers.io/gemplanner/',
        description: 'second iteration tool to help plan out what gems to select & buy in early PoE campaign',
        created: '2022-08-16'
    },
    {
        title: 'Relic Helper', ghLink: 'https://github.com/ennukee/relic-helper', liveLink: 'https://dbowers.io/relic-helper/',
        description: 'tool for helping users be able to figure out what relic sets they have access to in OSRS Shattered Relics league',
        created: '2022-01-30'
    },
    {
        title: 'Gem Planner V1', ghLink: 'https://github.com/ennukee/gem-planner', liveLink: 'https://dbowers.io/gem-planner/',
        description: 'first iteration tool to help plan out where to buy gems in early PoE campaign',
        created: '2021-04-11'
    },
    {
        title: 'PoE Seedcraft Stock', ghLink: 'https://github.com/ennukee/PoE-Seedcraft-Stock', liveLink: '',
        description: 'node script to assist in accumulating all stored harvest crafts in PoE prior to changes in 3.18',
        created: '2020-07-20'
    },
    {
        title: 'Corruption Replacer', ghLink: 'https://github.com/ennukee/corruption-replacer', liveLink: 'https://dbowers.io/corruption-replacer',
        description: 'tool to help generate items with specific affixes in SimC for WoW patch 8.3',
        created: '2020-06-04'
    },
  ]
};